// rsaUtils.js
import JSEncrypt from 'jsencrypt';
const publicKey='MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQD1EpCaFLKqgoxz+AfNyLlSscJT24o0i0v8uGjeCfcAlr1aJ9kYPCnSTVoN5Cam6lFk8dGYc65XUYI66/wP2pliiZZbLJSb6KjFHqxE+U24JGkHHBsp026By4GEfVcB1dFJLpu3kC7j5Vuj40azY8SVJ/TJJvu4v5ilQNufoLoAoqgeK0l85NBSAkbUOHn6yOENrJgmUVh+UoZNxKvP9X6CULioheOPrMo0yM+xIc8ouwJnTkN315AT9JGs/5Oro4sbqTLH4bMCfZtuil2t4FM7tOm5qHLVGMu0k/dNh0G7WZrN5aAnsoZMH3TMri2qUEsxaoCrnlXSorf2BcY8+YxLAgMBAAECgf98EOnwSiPClLrsYQrFiT6vBOgovvue0UxzcOgMTP8k5sSO351uQQbrCddZ/b/583J0dMQNNoMMF9EJNm5ky3jbNmW0j0N5Q+j5e1qHkHr7JEBtv2ZnX9VerNrknikHkZ2VCGnMg/5sLbCdRz6DkmS/hEebJ1RHzLcTvo6j2rpPMKUcqYmWN7CRoTy4Ah5ZDAV0cFuGxzixBlqkPEzS+tI2sM5neNJUWtKijqKxP7I485j92ZNRgKbipmpLgRKDCVaO+p/o8H3elA0Q4uCmHt7mnFfLqo0pd9wvBvu6koS9kuhPZ9Xie0avqFMnwMcrpt/5ZpvLozThKP+qDWdBiYECgYEA+qBz5KrCzdUmki9eEOlSxnG3ci169hj6ZOW24JnyiZEBUJh+xKV8TM2+X0WPjbqboff0655JIay45a99F8ZaLsG/HwCE+gaknf9ejlcfRjpOd/+PVJzdSPx6b1daKK5N4kEz3t110EV0PIkyulNdfJ0Lvb2BiYsrYrkM86pB0mMCgYEA+lOgxxglzygUMAE1M20vDcQijlYy7oFNX7HzcJ+691N1sCvsNKPqQ1lA0YHsWi2iGjnr+eNHYP68Q2hV6BxhXFxyzUg5KfQ0AuCtgHRjL1VjMoEw7S0hybpMKgYQ9Ht7CJTEbiYOK9F3cerVqAiq0OX/leaD57PHYEBtO3ILjvkCgYEAmLsjJRyy7kCQ6tEW3/NwUCKIinoQztxV6xraIXFvjknhpT3pMukuIJfZBbIcU2B+62txxAyHwI/DdaVF9DEaUBgd4kSsxLk7pFU1SETreB6cJyCENioJ6CqEakmvVc8zA0h81bnby/onZaSuV0HqXMBPoWdVA37eB6GBtRPyXMUCgYEA25gPG3hYeqCLDQ2SMPnf5DChq8F8TnPJf2Ao0SyeJCbnv9LYE9mTQN+EGAXkY7tST7VuB7lUPYdZebyGV+bFlfNXljN8Sgx6r+eO7HetJrG+ImjolbcYw9EUzWyi5QWJiZ6Prpzdo5zOLnW2VgC8cCLDkik0n0a7aPk7mYFTGGkCgYEAu9mrldb6orn5vNvAHaZGAUqvC2F+QuLXGz16FyBBCT74GGyWf4CmRLRkysjGs5ZPs8eSFPPCc3qwKK0od7sGSsy8MW3AHwccL3gS+uTZ/RnRmeI6UTQ20KdVgGvC32R7FyUPnJ85Z2HsjyDgnWqx8COmLNYbrEBEwuprbvsTomY='
/**
 * RSA 加密
 * @param {string} plainText - 明文
 * @param {string} publicKey - 公钥（PEM 格式）
 * @returns {string} - 加密后的 Base64 字符串
 */
export function encrypt(plainText:any) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);
  return encryptor.encrypt(plainText);
}


// 获取当前时间并格式化为 yyyy-MM-dd hh:23:34:39
export function getCurrentTimestamp(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = '23'; // 固定分钟为23
  const seconds = '34'; // 固定秒为34
  const millisecond = '39'; // 固定秒为34
  return `${year}${month}${day}${hours}${minutes}${seconds}${millisecond}`;
}
export function insertAtPosition(str: string, insert: string, position: number) {
  if (position > str.length) position = str.length;
  if (position < 0) position = 0;
  return str.slice(0, position) + insert + str.slice(position);
}

// 生成32位随机字符串
export function generateRandomString(length: number): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}